import Vue from "vue";
import Vuex from "vuex";
import { userModule } from "./user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: {
      show: false,
      message: "",
      color: "success",
    },
  },

  modules: {
    user: userModule
  },
  mutations: {
    async showSnackbar(state, payload) {
      const payloadData = await payload;
      state.snackbar.message = payloadData.message;
      state.snackbar.color = payloadData.type;
      state.snackbar.show = true;
    },
  }
});
